import {
    afterNextRender,
    ElementRef,
    inject,
    Injectable,
    Injector,
} from '@angular/core';

@Injectable()
export class FocusRestoration {
    private readonly injector = inject(Injector);
    private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);
    public afterRender(id?: string): void {
        afterNextRender(
            () => {
                const root = this.element.nativeElement;
                const preferred = id
                    ? [
                          ...root.querySelectorAll<HTMLInputElement>('input'),
                      ].find((input) => input.id === id)
                    : undefined;
                (
                    preferred ??
                    root.querySelector<HTMLInputElement>(
                        'qpx-quippy-pack-destination input'
                    )
                )?.focus();
            },
            { injector: this.injector }
        );
    }
}
